import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { fetchLatestResultOfHorsesWithOwner } from "../../redux/getReducer/getSingleOwnerStats";
import { fetchownermodalstats } from "../../redux/getReducer/getOwnerModalstats";
import Moment from "react-moment";
import PleaseWait from "../Reuseable/PleaseWait";
import arrow1 from "../../assets/image 13 (Traced).png";
import VideoFrame from "../Modal/VideoFrame";
import HorseModal from "../Modal/HorseModal";
import JockeyDetail from "../Modal/JockeyModal";
import RaceModal from "../Modal/RaceModal";
import { IoIosArrowDropdownCircle, IoMdPlay } from "react-icons/io";
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";
import ScrollContainer from "react-indiana-drag-scroll";
import { Accordion, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { truncateRaceType, toTitleCase } from "../../service/stringUtils";

// Custom isolated Style Import
// import "./OwnerStatsTabNew.css";

const OwnerStats = ({ id }) => {
  const { data: LatestResultOfHorsesWithOwner } = useSelector(
    (state) => state.LatestResultOfHorsesWithOwner,
  );
  const { data: ownermodalstats } = useSelector(
    (state) => state.ownermodalstats,
  );
  const navigate = useNavigate();
  const [activeAccordion, setActiveAccordion] = useState(null);
  const dispatch = useDispatch();
  const [year, setyear] = useState("");

  const [shows, setShows] = useState(false);
  const [modaldatas, setmodaldatas] = useState();
  const handleCloses = () => setShows(false);
  const handleShows = async (data) => {
    setmodaldatas(data);
    await setShows(true);
  };

  const [ShowHorse, setShowHorse] = useState(false);
  const [modaldatasHorse, setmodaldatasHorse] = useState();
  const handleShowHorse = (data) => {
    const id = data?._id || data;
    if (id) navigate("/horse-detail?" + id);
  };

  const [showRace, setShowRace] = useState(false);
  const [modaldataRace, setmodaldataRace] = useState();
  const handleCloseRace = () => setShowRace(false);
  const handleShowRace = (data) => { const id = data?._id || data; if (id) navigate("/race-detail?" + id); };

  const [ShowJockey, setShowJockey] = useState(false);
  const [modaldatasJockey, setmodaldatasJockey] = useState();
  const handleJockeyCloses = () => setShowJockey(false);
  const handleShowJockey = (data) => { const id = data?._id || data; if (id) navigate("/jockey-detail?" + id); };

  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");

  useEffect(() => {
    dispatch(fetchLatestResultOfHorsesWithOwner({ year, id }));
    dispatch(fetchownermodalstats({ id }));
  }, [dispatch, id, year]);

  const handleTrainerRecord = (selectedYear, index) => {
    if (activeAccordion === index) {
      setActiveAccordion(null);
      return;
    }
    setActiveAccordion(index);
    dispatch(fetchLatestResultOfHorsesWithOwner({ year: selectedYear, id, size: 400 }));
  };

  function distanceLabel(distance, rank) {
    const d = parseFloat(distance);
    if (d.toFixed(2) > 25) return "Dist";
    else if (d.toFixed(2) == 0.05 && rank < 80) return "SHd";
    else if (d.toFixed(2) == 0.1 && rank < 80) return "Hd";
    else if (d.toFixed(2) == 0.25 && rank < 80) return "Nk";
    else if (d.toFixed(2) == 0.01 && rank < 80) return "Ns";
    else if (d.toFixed(2) == 0.0 && rank < 80) return rank === 1 ? 0 : "Dh";
    else return distance;
  }

  return (
    <div className="my-new-stats-tab-wrapper">
      {/* --- MAIN HEADER (9 Columns) --- */}
      <div className="my-new-stats-thead">
        <div>{t("Year")}</div>
        <div>{t("Runs")}</div>
        <div>{t("Wins")}</div>
        <div>{t("Second")}</div>
        <div>{t("Third")}</div>
        <div>{t("Fourth")}</div>
        <div>{t("Fifth")}</div>
        <div>{t("Earning")}</div>
        <div>{t("Wins")}%</div>
        <div>{t("Place")}%</div>
        <div></div>
      </div>

      <div className="my-new-stats-accordion-container">
        {/* 1. OVERALL STATS ROW */}
        <Accordion activeKey={activeAccordion === "overall" ? "0" : ""}>
          <Accordion.Item
            eventKey="0"
            className="my-new-stats-acc-item"
          >
            <Accordion.Header className="my-new-stats-header-custom" onClick={() => handleTrainerRecord("", "overall")}>
              <div className="my-new-stats-header-grid">
                <div className="new-bold">OverAll</div>
                <div>{ownermodalstats.OverAll?.Runs}</div>
                <div>{ownermodalstats.OverAll?.wins}</div>
                <div>{ownermodalstats.OverAll?.second}</div>
                <div>{ownermodalstats.OverAll?.third}</div>
                <div>{ownermodalstats.OverAll?.fourth}</div>
                <div>{ownermodalstats.OverAll?.fifth}</div>
                <div className="new-bold">
                  {t("AED")} {Number(ownermodalstats.OverAll?.earning || 0).toLocaleString()}
                </div>
                <div>{Number(ownermodalstats.OverAll?.winspercentage || 0).toFixed(2)}</div>
                <div>{Number(ownermodalstats.OverAll?.placespercentage || 0).toFixed(2)}</div>
                <div style={{ textAlign: "right" }}>
                  {activeAccordion === "overall" ? (
                    <MdKeyboardArrowDown className="my-new-stats-arrow" />
                  ) : (
                    <MdKeyboardArrowRight className="my-new-stats-arrow" />
                  )}
                </div>
              </div>
            </Accordion.Header>
            <Accordion.Body style={{ padding: 0 }}>
              {activeAccordion === "overall" && (
                <InnerHistoryGrid
                  data={LatestResultOfHorsesWithOwner}
                  t={t}
                  cookiedata={cookiedata}
                  handleShowRace={handleShowRace}
                  handleShowJockey={handleShowJockey}
                  handleShows={handleShows}
                  handleShowHorse={handleShowHorse}
                  distanceLabel={distanceLabel}
                />
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        {/* 2. YEARLY STATS LOOP */}
        {ownermodalstats?.data &&
          ownermodalstats.data.map((item, i) => (
            <Accordion key={i} activeKey={activeAccordion === i ? "0" : ""}>
              <Accordion.Item
                eventKey="0"
                className="my-new-stats-acc-item"
              >
                <Accordion.Header className="my-new-stats-header-custom" onClick={() => handleTrainerRecord(item.Years, i)}>
                  <div className="my-new-stats-header-grid">
                    <div className="new-bold">{item?.Years}</div>
                    <div>{item.Detail?.Runs}</div>
                    <div>{item.Detail?.wins}</div>
                    <div>{item.Detail?.second}</div>
                    <div>{item.Detail?.third}</div>
                    <div>{item.Detail?.fourth}</div>
                    <div>{item.Detail?.fifth}</div>
                    <div className="new-bold">{t("AED")} {Number(item.Detail?.earning || 0).toLocaleString()}</div>
                    <div>{Number(item.Detail?.winspercentage || 0).toFixed(2)}</div>
                    <div>{Number(item.Detail?.placespercentage || 0).toFixed(2)}</div>
                    <div style={{ textAlign: "right" }}>
                      {activeAccordion === i ? (
                        <MdKeyboardArrowDown className="my-new-stats-arrow" />
                      ) : (
                        <MdKeyboardArrowRight className="my-new-stats-arrow" />
                      )}
                    </div>
                  </div>
                </Accordion.Header>
                <Accordion.Body style={{ padding: 0 }}>
                  {activeAccordion === i && (
                    <InnerHistoryGrid
                      data={LatestResultOfHorsesWithOwner}
                      t={t}
                      cookiedata={cookiedata}
                      handleShowRace={handleShowRace}
                      handleShowJockey={handleShowJockey}
                      handleShows={handleShows}
                      handleShowHorse={handleShowHorse}
                      distanceLabel={distanceLabel}
                    />
                  )}
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          ))}
      </div>

      {/* Modals preserved */}
      <Modal show={shows} onHide={handleCloses} size="lg" centered>
        <Modal.Body>
          <VideoFrame data={modaldatas} />
        </Modal.Body>
      </Modal>
      <Modal show={ShowJockey} onHide={handleJockeyCloses} size="lg" centered>
        <Modal.Body>
          <JockeyDetail data={modaldatasJockey} />
        </Modal.Body>
      </Modal>
      <Modal show={showRace} onHide={handleCloseRace} size="lg" centered>
        <Modal.Body>
          <RaceModal id={modaldataRace} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

// --- HELPER COMPONENT FOR 16-COLUMN GRID ---
const InnerHistoryGrid = ({
  data,
  t,
  cookiedata,
  handleShowRace,
  handleShowJockey,
  handleShows,
  handleShowHorse,
  distanceLabel,
}) => {
  if (data === undefined)
    return (
      <div className="text-center py-4">
        <PleaseWait />
      </div>
    );
  if (!data || data.length === 0)
    return <div className="text-center py-4">{t("No History Yet")}</div>;

  const sortedData = [...data].sort((a, b) => {
    const aDate = new Date(a?.RaceResultData?.StartTime || a?.RaceResultData?.Day || 0).getTime();
    const bDate = new Date(b?.RaceResultData?.StartTime || b?.RaceResultData?.Day || 0).getTime();
    return bDate - aDate;
  });

  return (
    <ScrollContainer className="my-new-stats-inner-scroll">
      <div className="my-new-stats-inner-table">
        <div className="my-new-stats-inner-thead">
          <div>{t("Date")}</div><div>{t("Crs")}</div><div>{t("Horse Name")}</div><div>{t("Dist")}</div><div>{t("RT")}</div><div>{t("Time")}</div><div>{t("Jockey")}</div><div>{t("Wgt")}</div><div>{t("FP")}</div><div>{t("Len")}</div><div>{t("RN")}</div><div>{t("BtBy")}</div><div>{t("Kgs")}</div><div>{t("Draw")}</div><div>{t("OR")}</div><div>{t("Link")}</div>
        </div>
        <div className="my-new-stats-inner-tbody">
          {sortedData.map((item, idx) => {
            const ground =
              item.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameEn;
            const rowBg =
              ground === "Dirt"
                ? "#e3d4ca"
                : ground === "Turf"
                ? "#cbedba"
                : "#949494";
            return (
              <div
                key={idx}
                className="my-new-stats-inner-row"
                style={{ backgroundColor: rowBg, color: "#343433" }}
              >
                <div onClick={() => handleShowRace(item.RaceID)} className="new-clickable-white">
                  <Moment format="DD/MM/YYYY">{item.RaceResultData?.StartTime || item.RaceResultData?.Day}</Moment>
                </div>
                <div>
                  {cookiedata === "en" ? item.RaceResultData?.RaceCourseData?.AbbrevEn : item.RaceResultData?.RaceCourseData?.AbbrevAr}({cookiedata === "en" ? item.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameEn?.charAt(0) : item.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameAr?.charAt(0)})
                </div>
                <div className="new-clickable-white" onClick={() => handleShowHorse(item.HorseIDData?._id)}>
                  {cookiedata === "en" ? toTitleCase(item.HorseIDData?.NameEn || "-") : (item.HorseIDData?.NameAr || "-")}
                </div>
                <div>{item.RaceResultData?.TrackLengthData?.TrackLength}</div>
                <div className="new-truncate-cell">
                  <span>{cookiedata === "en" ? toTitleCase(truncateRaceType(item.RaceResultData?.RaceTypeModelData?.NameEn)) : item.RaceResultData?.RaceTypeModelData?.NameAr}</span>
                </div>
                <div>{item.RaceResultData?.RaceTime || "-"}</div>
                <div onClick={() => handleShowJockey(item.JockeyOnRaceDataResult?._id)} className="new-clickable-white">{cookiedata === "en" ? toTitleCase(item.JockeyOnRaceDataResult?.ShortNameEn) : item.JockeyOnRaceDataResult?.ShortNameAr}</div>
                <div>{item.HorseIDData ? item.HorseIDData.BeatenByJockeyWeight : 0}</div>
                <div>{cookiedata === "en" ? toTitleCase(item.FinalPositionDataHorse?.NameEn) : item.FinalPositionDataHorse?.NameAr}</div>
                <div>{distanceLabel(item.Distance, item.FinalPositionDataHorse?.Rank)}</div>
                <div>{item.RaceResultData?.Runners}</div>
                <div className="new-truncate-cell new-clickable-white" onClick={() => handleShowHorse(item.BeatenByData?._id || item.BeatenByData)}>
                  {item.BeatenByData ? toTitleCase(cookiedata === "en" ? item.BeatenByData?.NameEn : item.BeatenByData?.NameAr) : toTitleCase(cookiedata === "en" ? item.HorseIDData?.HorseBeatenByEnglishName : item.HorseIDData?.HorseBeatenByArabicName)}
                </div>
                <div>{item.BeatenByData?.WinningHorseJockeyWeight ? Number(item.BeatenByData.WinningHorseJockeyWeight).toFixed(1) : 0}</div>
                <div>{item.RaceResultData?.Draw}</div>
                <div>{item.Rating || 0}</div>
                <div onClick={() => handleShows(item.VideoLink)} className="my-new-play-btn-circle"><IoMdPlay /></div>
              </div>
            );
          })}
        </div>
      </div>
    </ScrollContainer>
  );
};

export default OwnerStats;
